// extracted by mini-css-extract-plugin
export default {"animatedArrow":"styles-module__animatedArrow--DUAq5","linkArrow":"styles-module__linkArrow--J21h9"};